<template>
    <div class="redesign-header">
        <h1>{{ title }}</h1>
        <div class="yellow-accent" :style="{ backgroundColor: accentColor }"></div>
        <hr class="header-divider" />
    </div>
</template>

<script>
export default {
    name: "GarantieHeader",
    props: {
        title: {
            type: String,
            required: true
        },
        accentColor: {
            type: String,
            default: "#ffc107"
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Garantie/shared/GarantieHeader.vue